<template>
    <child-layout title="Export Logs Details">
        <ag-grid-server-side
            id="exportLogDetails"
            :server-side-datasource="serverSideDatasource"
            server-side-store-type="full"
            suppress-row-click-selection="true"
            :column-defs="columnDefs"
        />
    </child-layout>
</template>

<script>
import ChildLayout from '@/components/layout/ChildLayout'
import AgGridServerSide from '@/components/table/AgGridServerSide'
import ColumnDef from '@/helpers/ag-grid/columnDef/exportLog/details'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'ExportLogDetails',
    components: {
        ChildLayout,
        AgGridServerSide,
    },
    data: () => ({
        columnDefs: ColumnDef,
    }),
    computed: {
        ...mapGetters({
            fetching: 'exportLogDetails/getFetching',
            items: 'exportLogDetails/getItems',
            lea: 'getDistrictLea',
        }),
        batchId() {
            return this.$route.params.batchId
        },
        etlStatusId() {
            return this.$route.params.etlStatusId
        },
    },
    methods: {
        ...mapActions({
            fetchRows: 'exportLogDetails/get',
        }),
        serverSideDatasource: function () {
            const fetch = async () => {
                await this.fetchRows({
                    lea: this.lea,
                    batchId: this.batchId,
                    etlStatusId: this.etlStatusId,
                })

                return this.items
            }

            return {
                getRows: async function (params) {
                    const data = await fetch()

                    params.successCallback(data, data.length)
                },
            }
        },
    },
}
</script>

<style scoped>

</style>